import { logError } from '@zg-rentals/log-error';
import type { SyntheticEvent } from 'react';

/**
 * @file
 * Until all rentals-js apps are using the latest from page-frame-service
 * we have to manually attach the "cookie preference" handler.
 * This module exports a method `onPageFrameLinkClick` which should be added
 * as the `onLinkClick` prop to the "PageFooter" component from page-frame.
 */

const DATAGRAIL_ERROR_TYPE_PREFIX = 'DataGrailError';
const COOKIE_PREFERENCE_CLASS_NAME = 'cookie-preference';

type DataGrailBannerApi = {
  showLayer?: (layerId: string) => void;
};

export function showDataGrailConsentPreferences() {
  try {
    const bannerApi =
      typeof window === 'undefined'
        ? undefined
        : (window as Window & { DG_BANNER_API?: DataGrailBannerApi }).DG_BANNER_API;

    if (
      typeof bannerApi === 'object' &&
      bannerApi !== null &&
      'showLayer' in bannerApi &&
      typeof bannerApi.showLayer === 'function'
    ) {
      bannerApi.showLayer('categories-layer');
    }
  } catch (error) {
    logError({
      error,
      errorType: `${DATAGRAIL_ERROR_TYPE_PREFIX}__ShowConsentBanner`,
      context: 'Failed to open Datagrail consent banner',
    });
  }
}

// it is recommended that all apps use the page frame service, not the components directly but...
// for apps that aren't using page frame service, ie, using the PageFooter component directly
// they should use this for the `onLinkClick` prop
export function onPageFrameLinkClick(event: SyntheticEvent) {
  const target = event?.target;
  if (
    target != null &&
    'classList' in target &&
    target.classList !== null &&
    typeof target.classList === 'object' &&
    'value' in target.classList &&
    typeof target.classList.value === 'string' &&
    target.classList.value.includes(COOKIE_PREFERENCE_CLASS_NAME)
  ) {
    showDataGrailConsentPreferences();
  }
}

export {
  DATAGRAIL_CONSENT_CUSTOM_STYLE_ID,
  DATAGRAIL_CONSENT_SCRIPT_ID,
  DATAGRAIL_CONSENT_SCRIPT_SRC,
  getDataGrailHeadHtml,
  getDataGrailStyleContents,
} from './script';
